import { j as o } from "../../../_virtual/jsx-runtime.js";
import { Route as s } from "react-router-dom";
import m from "./Login.js";
import n from "./SetPassword.js";
import p from "./ForgotPassword.js";
import i from "./comps/Layout.js";
function u(r) {
  const { logo: t, onSuccess: e } = r;
  return /* @__PURE__ */ o.jsxs(s, { element: /* @__PURE__ */ o.jsx(i, {}), children: [
    /* @__PURE__ */ o.jsx(s, { path: "/login", element: /* @__PURE__ */ o.jsx(m, { logo: t, onSuccess: e }) }, "login"),
    /* @__PURE__ */ o.jsx(s, { path: "/set-password", element: /* @__PURE__ */ o.jsx(n, { logo: t }) }, "set-password"),
    /* @__PURE__ */ o.jsx(s, { path: "/forgot-password", element: /* @__PURE__ */ o.jsx(p, { logo: t }) }, "forgot-password")
  ] });
}
export {
  u as createAuthRoutes
};
